<template>
  <section>
    <div class="modal" id="customer_complaint" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">Detailed Complaint View</h4>
          </div>
          <div class="modal-body">
            <ul class="list-unstyled">
              <li>
                  {{complaint}}
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ViewComplaintDetails",
  data() {
    return {
      customerName: '',
      complaint: '',
    }
  },
  methods: {
    load (complaint, customerName) {
      this.complaint = complaint;
      this.customerName = customerName;
      $("#customer_complaint").modal("show");
    }
  }
}
</script>

<style scoped>

</style>